export default __webpack_public_path__ + "img/go-to-top-btn.svg";